import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

interface Props {
  isAGN?: any;
}

export default makeStyles<Theme, Props>(
  (theme?: any) =>
    createStyles({
      reorder: {
        '& svg': {
          width: '20px',
        },
      },
      tableSection: {
        marginTop: '1rem',

        '& table > thead > th': {
          textAlign: 'left',
        },
      },
      header: {
        margin: theme.spacing(2, 0, 1),
        '& *': {
          boxSizing: 'border-box',
        },
        '& > h1': {
          marginBottom: theme.spacing(2),
        },
      },
      content: {
        '& *': {
          boxSizing: 'border-box',
        },
      },
      subtitleLiberarEmLote: {
        fontFamily: '"Exo 2", sans-serif!important',
        fontSize: '18px',
        marginBottom: '1rem',
        fontWeight: 700,
        color: sicrediColor.secondarySicrediDarker,
      },
      situacao: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        lineHeight: 1.5,
        color: sicrediColor.secondarySicrediDarker,
      },
      video: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        '& .MuiCard-root': {
          flex: 'auto',
        },
      },
      semVideo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        '& button': {
          textAlign: 'left',
        },
      },
      data: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
      },
      botoesSituacao: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem',
        fontFamily: '"Nunito", sans-serif',
        [theme.breakpoints.down('md')]: {
          justifyContent: 'center',
        },
        '& .MuiButton-root:not(:last-of-type)': {
          marginRight: theme.spacing(2.5),
        },
      },
      botaoBloquear: {
        backgroundColor: sicrediColor.dangerSicredi,
        color: 'white',
        '&:hover': {
          backgroundColor: sicrediColor.dangerSicredi,
          filter: 'brightness(0.88)',
        },
      },
      syncLabel: {
        fontWeight: 'bold',
      },
      updatePresence: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',

        '& > button': {
          marginRight: '-14px',
        },
      },
      labelGrid: {
        display: 'grid',
        [theme.breakpoints.up('xs')]: {
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: '16px',
        },
        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '24px',
        },
        [theme.breakpoints.up('lg')]: {
          gridTemplateColumns: (props) =>
            props.isAGN ? 'repeat(6, 1fr)' : 'repeat(5, 1fr)',
          gap: (props) => (props.isAGN ? '24px' : '30px'),
        },
      },
      labelValueIcon: {
        fontSize: '1.2em',
      },
      contentModal: {
        lineHeight: '26px',
      },
      badgeDetails: {
        borderRadius: '50px',

        '& > span': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.25rem 1rem 0.25rem 0.3rem',

          '& > svg': {
            fontSize: '16px',
            marginRight: '0.5rem',
          },
        },

        '&.padrao': {
          backgroundColor: sicrediColor.warningSicrediLight,
          color: '#765F00',
        },
        '&.coordenador': {
          backgroundColor: '#CBE5FD',
          color: '#2B517B',
        },
        '&.conselho': {
          backgroundColor: '#ffcd98',
          color: '#765F00',
        },
      },
      badgeTable: {
        '& span': {
          backgroundColor: sicrediColor.dangerSicrediLight,
          color: sicrediColor.dangerSicrediDark,
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.25rem 1rem 0.25rem 0.3rem',

          '& svg': {
            fontSize: '16px',
            marginRight: '0.5rem',
          },
        },
      },
      detalhesIcons: {
        '& > svg': {
          marginRight: '0.5rem',
          fontSize: '22px',
        },
      },
      liberarVotacaoButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '1rem 0rem',

        '& svg': {
          fontSize: '20px',
        },
      },
    }),
  { name: 'AssembleiaAssessor' }
);
